import { getCombinedGraphValue } from '../helpers/performanceUtil';

const initialState = {
    isPinging: false,
    ecpdId: '',
    nibId: '',
    nodes: [],
    coreGraphData: [],
    inventory: {},
    kpiOverviewData: [],
    kpiMetricLastUpdateDate: undefined,
    isLoadingKpiCoreGraphData: false
};

export const kpiReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PING': {
            return { isPinging: true };
        }

        case 'PONG': {
            return { isPinging: false };
        }

        case 'CORE_NETWORK_DROP_DOWN_LIST': {
            return { ...state, nodes: action.nodes, ecpdId: action.ecpdId, nibId: action.nibId };
        }
        case 'SET_INVENTORY_DATA': {
            return { ...state, inventory: action.inventory };
        }
        // for successful data
        case 'KPI_CORE_NETWORK_GRAPH_DATA_SUCCESS': {
            if (action.response && action.response.length > 0) {
                const responses = action.response;
                if (!!responses[0]?.data?.metrics && !!responses[1]?.data?.metrics && !!action.isEpg && !action.isSA5GAMFCoreNodeRequest) {
                    const uplinkValues = responses[1]?.data?.metrics[0]?.values;
                    // Statically created combined throughput response
                    const combineThroughputResponse = {
                        data: {
                            metrics: [
                                {
                                    metric: {
                                        name: 'oslte_kpi_metrics_COMBINE_THROUGHPUT',
                                        labels: {
                                            ...responses[0]?.data?.metrics[0]?.metric?.labels
                                        }
                                    },
                                    values: responses[0]?.data?.metrics[0]?.values.map(({ value: downlinkValue, time }) => {
                                        const uplinkValue = uplinkValues.find((el) => el.time === time)?.value;
                                        const combinedValue = getCombinedGraphValue(downlinkValue, uplinkValue);
                                        return combinedValue
                                            ? {
                                                  time,
                                                  value: combinedValue
                                              }
                                            : {
                                                  time
                                              };
                                    })
                                }
                            ]
                        }
                    };
                    responses.splice(0, 0, combineThroughputResponse);
                }

                const metrixMap = responses
                    .filter((x) => x)
                    .map(({ data }) => {
                        if (data && data.metrics) {
                            const dataTemp = [];
                            let name;
                            data.metrics.forEach((val) => {
                                name = val.metric.name;
                                dataTemp.push(...val.values);
                            });

                            return { metric: name, values: dataTemp };
                        }
                    });

                const metrix = metrixMap.reduce((acc, val) => {
                    if (val && val.metric && val.values) return { ...acc, [val.metric]: val.values };
                }, {});
                if (metrix) {
                    const metrixData = Object.keys(metrix).map((key) => ({ key, arrVal: metrix[key] }));
                    const sortedData = metrixData.sort(function (a, b) {
                        return a.arrVal.time - b.arrVal.time;
                    });
                    return { ...state, isLoadingKpiCoreGraphData: false, coreGraphData: sortedData };
                } else {
                    return { ...state, isLoadingKpiCoreGraphData: false, coreGraphData: [] };
                }
            } else {
                return { ...state, isLoadingKpiCoreGraphData: false, coreGraphData: [] };
            }
        }
        case 'KPI_CORE_RESET_GRAPH_DATA': {
            return { ...state, coreGraphData: [] };
        }
        case 'KPI_OVERVIEW_DATA': {
            return { ...state, ...action.payload };
        }
        case 'KPI_USAGE_DATA': {
            return { ...state, ...action.payload };
        }
        case 'KPI_VIEW_LAST_UPDATED_TIME': {
            return { ...state, kpiMetricLastUpdateDate: action.kpiMetricLastUpdateDate };
        }
        case 'KPI_CORE_NETWORK_NDAC_DATA_REQUEST':
        case 'KPI_CORE_NETWORK_MME_DATA_REQUEST':
        case 'KPI_CORE_NETWORK_SA5G_AMF_DATA_REQUEST':
        case 'KPI_CORE_NETWORK_EPG_DATA_REQUEST': {
            return { ...state, isLoadingKpiCoreGraphData: true };
        }
        case 'GRAPH_DATA_RADIO_API_ERROR': {
            return { ...state, isLoadingKpiCoreGraphData: false };
        }

        default:
            return state;
    }
};
